import React from 'react'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'

const BusinessSegmentations = ({
  header,
  body
}: {
  header: any
  body: any
}) => {
  return (
    <section className='bg-gray-100 mb-10 lg:mb-16 relative rounded-[1.5rem] lg:rounded-[3rem]'>
      <video
        autoPlay
        loop
        muted
        className='absolute top-0 lazyloaded left-0 w-full h-full object-cover rounded-[1.5rem] lg:rounded-[3rem]'
        playsInline
        preload='metadata'
      >
        <source
          src='https://videos.ctfassets.net/tgv5pu8pgmos/RCG7MWX5oNpgbgXzAv2mx/f4fc861258ddc3e8dc155305df608ac3/business-component-broll.webm'
          type='video/webm'
        />
        <source
          src='https://videos.ctfassets.net/tgv5pu8pgmos/2FvPILUGtM1UDYYP0ESkVU/f92903d5f12affc06f83395caec7bdbf/business-component-broll.mp4'
          type='video/mp4'
        />
        Your browser does not support the video tag.
      </video>
      <div className='ds-wrapper relative z-10'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12 py-10 lg:py-36'>
            <div className='flex flex-col items-center max-w-[342px] lg:max-w-[46.5rem] mb-6 lg:mb-10 mx-auto text-center'>
              <Typography
                as='h2'
                variation='h2'
                classes='font-effra font-base !leading-[1.688rem] lg:!leading-[3rem] mb-2 lg:mb-4 !text-[1.938rem] lg:!text-[45px] text-white'
              >
                {header.heading}
              </Typography>
              <Typography
                as='p'
                variation='default'
                classes='font-effra font-base !leading-[1.688rem] lg:!leading-[2rem] !text-[1.375rem] lg:!text-[1.625rem] text-white'
              >
                {header.description}
              </Typography>
            </div>
            <div className='flex justify-center items-center flex-wrap gap-4 lg:gap-x-2 lg:gap-y-4 w-[343px] lg:w-[936px] mx-auto'>
              {body.segments.map((segment: any, i: number) => {
                return (
                  <Button
                    classes='w-[343px] md:!w-[343px] lg:!w-auto'
                    heapInteraction={segment.heapInteraction}
                    href={segment.url}
                    variation='pill'
                    key={`segment-${i}`}
                  >
                    {segment.label}
                    <img
                      src={resolvePrefix('/svg/chevron-right-white.svg')}
                      className='ml-auto lg:ml-1'
                      alt='white cheveron right'
                    />
                  </Button>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BusinessSegmentations
